import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Roles, UserRole } from '@shared/models/types';
import { ProfileService } from '@shared/services/api/profile.service';
import { NGXLogger } from 'ngx-logger';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';

export const roleGuard: CanActivateFn = (route): Observable<boolean> => {
  const profileService = inject(ProfileService);
  const logger = inject(NGXLogger);
  const router = inject(Router);

  return profileService.role$.pipe(
    switchMap((role) => {
      const roles = (route.data['roles'] as UserRole[]) || [];
      if (!role) {
        return throwError(() => new Error('No user found'));
      }

      if (!roles.includes(role)) return throwError(() => new Error('Current role cant see this page', { cause: role }));
      return of(true);
    }),
    catchError((error) => {
      logger.error('[Role guard] Error checking user:', error);
      if (error.cause && error.cause === Roles.PARTNER) {
        router.navigate(['/final-users']);
      } else {
        router.navigate(['/home']);
      }

      return of(false);
    })
  );
};
